const OTHER_VALUE = "Muu, mikä?";

const makeTestSlug = (value) => String(value).toLowerCase().replaceAll(" ", "-").replaceAll("/", "-").replaceAll("?", "").replaceAll("ä", "a").replaceAll("ö", "o");

const defaultHelp = (field) => {
  if (field.helpText) return field.helpText;
  if (field.type === "multiselect") return "Valitse yksi tai useampi vaihtoehto. Voit lisätä oman vaihtoehdon, jos valmis lista ei riitä.";
  if (field.type === "select" || field.type === "radio") return "Valitse lähin vaihtoehto. Jos mikään ei sovi, valitse “Muu, mikä?” ja kirjoita oma vastauksesi.";
  if (field.type === "textarea") return "Kirjoita omin sanoin. Yksi tai kaksi lausetta riittää hyvin.";
  return "Kirjoita lyhyesti ja käytännönläheisesti.";
};

export const HybridFormField = ({ field, value, otherValue, onChange, onOtherChange, testId }) => {
  const options = field.options || [];
  const optionGroups = field.optionGroups || [];
  const groupedOptions = optionGroups.flatMap((group) => group.options || []);
  const allOptions = [...options, ...groupedOptions];
  const selectedList = Array.isArray(value) ? value : value ? [value] : [];
  const showOther = field.allowOther || allOptions.includes(OTHER_VALUE);
  const otherSelected = field.type === "multiselect" ? selectedList.includes(OTHER_VALUE) : value === OTHER_VALUE;

  const baseInputClass = "w-full rounded-2xl border border-transparent bg-[#F5F3EC] px-4 py-3 text-sm text-[#2C2F2E] outline-none transition-colors duration-200 placeholder:text-[#5C6360]/55 focus:border-[#4A6753]/40 focus:bg-white focus:ring-4 focus:ring-[#4A6753]/10";

  const toggleMulti = (option) => {
    const next = selectedList.includes(option) ? selectedList.filter((item) => item !== option) : [...selectedList, option];
    onChange(next);
  };

  return (
    <div className="block" data-testid={`${testId}-wrapper`}>
      <label htmlFor={field.id} className="mb-2 block text-sm font-bold text-[#2C2F2E]" data-testid={`${testId}-label`}>
        {field.label}
      </label>

      {field.type === "textarea" ? (
        <textarea id={field.id} value={value || ""} onChange={(event) => onChange(event.target.value)} placeholder={field.placeholder} rows={5} className={baseInputClass} data-testid={testId} />
      ) : field.type === "select" ? (
        <>
          <select id={field.id} value={value || ""} onChange={(event) => onChange(event.target.value)} className={baseInputClass} data-testid={testId}>
            <option value="" data-testid={`${testId}-option-empty`}>Valitse...</option>
            {optionGroups.map((group) => (
              <optgroup key={group.label} label={group.label} data-testid={`${testId}-group-${makeTestSlug(group.label)}`}>
                {group.options.map((option) => (
                  <option key={`${group.label}-${option}`} value={option} data-testid={`${testId}-option-${makeTestSlug(option)}`}>{option}</option>
                ))}
              </optgroup>
            ))}
            {options.map((option) => (
              <option key={option} value={option} data-testid={`${testId}-option-${makeTestSlug(option)}`}>{option}</option>
            ))}
          </select>
          {showOther && otherSelected && (
            <input value={otherValue || ""} onChange={(event) => onOtherChange(event.target.value)} placeholder="Kirjoita oma vaihtoehto" className={`${baseInputClass} mt-3 bg-white ring-1 ring-[#E8E5D9]`} data-testid={`${testId}-other-input`} />
          )}
        </>
      ) : field.type === "radio" ? (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2" data-testid={`${testId}-radio-group`}>
          {options.map((option) => (
            <button key={option} type="button" onClick={() => onChange(option)} className={`rounded-2xl px-4 py-3 text-left text-sm font-bold transition-colors ${value === option ? "bg-[#4A6753] text-white" : "bg-[#F5F3EC] text-[#2C2F2E] hover:bg-[#E8E5D9]"}`} data-testid={`${testId}-radio-${makeTestSlug(option)}`}>
              {option}
            </button>
          ))}
          {showOther && otherSelected && (
            <input value={otherValue || ""} onChange={(event) => onOtherChange(event.target.value)} placeholder="Kirjoita oma vaihtoehto" className={`${baseInputClass} sm:col-span-2 bg-white ring-1 ring-[#E8E5D9]`} data-testid={`${testId}-other-input`} />
          )}
        </div>
      ) : field.type === "multiselect" ? (
        <div className="flex flex-wrap gap-2" data-testid={`${testId}-multiselect-group`}>
          {options.map((option) => {
            const selected = selectedList.includes(option);
            return (
              <button key={option} type="button" onClick={() => toggleMulti(option)} className={`rounded-full px-4 py-2 text-sm font-bold transition-colors ${selected ? "bg-[#4A6753] text-white" : "bg-[#F5F3EC] text-[#2C2F2E] hover:bg-[#E8E5D9]"}`} data-testid={`${testId}-multi-${makeTestSlug(option)}`}>
                {option}
              </button>
            );
          })}
          {showOther && otherSelected && (
            <input value={otherValue || ""} onChange={(event) => onOtherChange(event.target.value)} placeholder="Kirjoita oma vaihtoehto" className={`${baseInputClass} mt-1 basis-full bg-white ring-1 ring-[#E8E5D9]`} data-testid={`${testId}-other-input`} />
          )}
        </div>
      ) : (
        <input id={field.id} value={value || ""} onChange={(event) => onChange(event.target.value)} placeholder={field.placeholder} className={baseInputClass} data-testid={testId} />
      )}

      <p className="mt-2 text-xs leading-5 text-[#5C6360]" data-testid={`${testId}-help-text`}>{defaultHelp(field)}</p>
    </div>
  );
};